export default __webpack_public_path__ + "static/media/gu.60cbe207.svg";